import { Component, ViewChild } from '@angular/core';
import { Platform, MenuController, Nav, ModalController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { notificaciones } from '../pages/notificaciones/notificaciones';
import { servicios_ocre } from '../pages/servicios_ocre/servicios_ocre';
import { datos } from '../providers/datos';
import { Login } from '../pages/login/login';
import { mis_servicios } from '../pages/mis_servicios/mis_servicios';
import {html} from '../pages/html/html';
import {Modal} from '../pages/modal/modal';


@Component({
  templateUrl: 'app.html'

})

export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage : any = notificaciones;
  
  pages: any;
  params:any;
  leftMenuTitle: string;


  pagina ={
    "title": "Servicios de belleza ocre",
    "logo":"assets/images/usuario.png",
    "background": ""
  }

  constructor(public platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public menu: MenuController,
    private datos:datos,

    
    public modalCtrl: ModalController) {

    //Change Color StatusBar
    // this.statusBar.backgroundColorByHexString('#96296d');
    // this.headerColor.tint('#ffgf');
    // statusBar.overlaysWebView(true);
    this.statusBar.styleDefault();
    this.statusBar.styleLightContent();
    this.pages = this.getAllThemes();
    this.leftMenuTitle = "";
    this.initializeApp();


  }

  initializeApp() {
    this.platform.ready().then(() => {
      setTimeout(() => {
      this.splashScreen.hide();
      // this.nav.push(servicios_ocre);
      }, 1000);

    });

    
  }

  presentProfileModal() {
    // this.modalCtrl.create("IntroPage");
  }


  getPerfil(){
    let modal = this.modalCtrl.create(Modal,{"item":"" },{cssClass: "transactionConfirm-modal"});
      modal.onDidDismiss(data1 => {
          console.log(data1);
          let p = 
          {
            "id": this.datos.login.id,
            "desde": this.datos.resumen.desde,
            "hasta": this.datos.resumen.hasta
          };
      
      
      if (data1.dato>0){
        this.datos.loader(1);
        this.datos.getPerfil(p)
                   .subscribe((data) => {
                    this.datos.loader(0);
                    this.openHtml(data.data);
                
                    },
                   (error: any) => {
                      this.datos.loader(0);
                      this.datos.Toast("ERROR",2000);
                       console.log(error);
                   });
      }
         
      });



    modal.present();
   
  }




  login(){
    this.nav.push(Login);
  }


  openHtml(item){
    item ={
     titulo:'Detalles',
     html:item.html
   }
 
     console.log("modal");
      let modal = this.modalCtrl.create(html,{"item":item },{cssClass: ""});

     modal.present();
   
   
   
 }



  salir(){
    this.datos.login.login=0;
    this.datos.login.id=0;
    this.datos.login={
      user:"",
      nombre:"",
      apellido1:"",
      apellido2:"",
      pass:"",
      puntos:"",
      login:0,
      id:0
    
    }
    this.login();

  }
  openPage(page) {



  if (page.theme=="notificaciones_ocre") {console.log("pagos"); this.nav.push(notificaciones);}
  if (page.theme=="servicios_ocre") {console.log("servicios_ocre"); this.nav.push(servicios_ocre);}
  if (page.theme=="mis_servicios_ocre") {console.log("mis_servicios"); this.nav.push(mis_servicios);}


  
  

}



  getPageForOpen(value: string): any {
    return null;
  }


  getAllThemes = (): Array<any> => {
    return [

      // {"title" : "Servicios", "theme"  : "servicios_ocre",  "icon" : "ios-list-outline", "listView" : false, "component":"", "singlePage":false},
      {"title" : "Promociones", "theme"  : "pormociones_ocre",  "icon" : "ios-contact-outline", "listView" : false, "component":"", "singlePage":false},
      {"title" : "Mis Servicios", "theme"  : "mis_servicios_ocre",  "icon" : "ios-clock-outline", "listView" : false, "component":"", "singlePage":false},
      {"title" : "Pagos", "theme"  : "pagos_ocre",  "icon" : "ios-card", "listView" : false, "component":"", "singlePage":false},
      {"title" : "Notificaciones","theme":"notificaciones_ocre" ,  "icon" : "ios-notifications-outline", "listView" : false, "component":"", "singlePage":false},
      {"title" : "Contactenos", "theme"  : "contactos",  "icon" : "ios-help-circle-outline", "listView" : false, "component":"", "singlePage":false},
      {"title" : "Acerca de", "theme"  : "about",  "icon" : "ios-alert-outline", "listView" : false, "component":"", "singlePage":false}


    ];
  };

  getDataForTheme = () => {
    return {
      "background": "assets/images/usuario.png",
      "image": "assets/images/logo/2.png",
      "title": ""
    };
  };

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts